import { RefObject, useEffect } from 'react';

export const useOutsideClick = (ref: RefObject<HTMLElement>, callback: () => void) => {
  const handleClick = (e: MouseEvent) => {
    if (e.target && ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };
  const handleKeyboardClick = (e: KeyboardEvent) => {
    if (e.target && ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeyboardClick);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeyboardClick);
    };
  });
};
